import React from 'react'
import './TestimonialsTitle.component.scss'

const TestimonialsTitle = () => {
  return (
    <section className='testimonials-title'>
      <div className='testimonials-title__inner'>
        <h2 className='testimonials-title__heading'>
          <span>Trusted by Individuals and Seniors Nationwide*</span>
        </h2>
      </div>
    </section>
  )
}

export default TestimonialsTitle
